import React from "react";
import { timesheetsRef } from "../firebase";
import { useDeltaSyncedCollection } from "../customHooks/useDeltaSyncedCollection";

const TimesheetsContext = React.createContext(null);

// All timesheets created by the user's associated accounts - kept in sync with Firestore through
// this device's cache plus a listener on recently modified documents, so every timesheet is
// available to list and search, not just recent ones. See useDeltaSyncedCollection.
const TimesheetsProvider = (props) => {
  const { docs, loading } = useDeltaSyncedCollection(timesheetsRef);

  return (
    <TimesheetsContext.Provider value={{ timesheets: docs, loading }}>
      {props.children}
    </TimesheetsContext.Provider>
  );
};

export { TimesheetsProvider, TimesheetsContext };
